import {Component, forwardRef, Injector, Input} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => BillingCycleSingleSelectEditControlComponent),
    multi: true
};

@Component({
    selector: "wbo-billing-cycle-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        CUSTOM_VALUE_ACCESSOR
    ]
})
export class BillingCycleSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<any> {
    constructor(injector: Injector) {
        super(undefined, injector);
        this.allowClearSelectionOption = false;
    }

    private _validBillingCycles: string[];

    get validBillingCycles(): string[] {
        return this._validBillingCycles;
    }

    @Input()
    set validBillingCycles(validBillingCycles: string[]) {
        this._validBillingCycles = validBillingCycles;
        this.buildData([
            {label: "wbo.account.edit.billingcycle.option.none", value: "none"},
            {label: "wbo.account.edit.billingcycle.option.weekly", value: "weekly"},
            {label: "wbo.account.edit.billingcycle.option.monthly", value: "monthly"}
        ].filter(option => this._validBillingCycles.find(cycle => cycle === option.value)));
    }
}
